import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { alpha } from '@mui/material/styles'
import { useSmartTranslation } from '../../../../generic/hooks/useSmartTranslation'
import { CONTROL_RADIUS } from '../detailControls'

// ADDENDUM 49 (§2.3) — «Sin valores · … · sin grupo» + un botón que lo abre todo.
//
// ⚠️⚠️ PLEGAR NO ES OCULTAR, y la distinción es la razón de que este componente exista en vez de
// un simple `hidden`. El addendum 16 A decidió que cuatro campos de preparación muestran EL CERO
// ALMACENADO —2.867 de 2.907 jobs guardan un cero, y decir "pendiente" en casi todas las
// operaciones era peor que decir lo que dice la tabla—. Si al plegarlos DESAPARECIERAN, ese
// addendum quedaría revocado sin que nadie lo decidiera.
//
// Por eso la línea resumen ENUMERA lo que pliega, con su valor: "preparación inicial 0s, 0
// operarios" sigue leyéndose sin abrir nada. Lo que se retira es el PESO —cuatro tarjetas
// compitiendo con las incidencias abiertas—, no el dato.
//
// 📌 EL RESUMEN SE CONSTRUYE FUERA. Cada pantalla sabe qué campos suyos no exigen acción; aquí solo
// se sabe cómo se pliegan. Igual que `ExpansionHeadline`, lo común es la FORMA.
const CollapsedFieldsLine = ({ testId = 'collapsed-fields', summary = [], openLabel, headline = '', children = null }) => {
  const { t_ } = useSmartTranslation()
  const [open, setOpen] = useState(false)

  if (summary.length === 0 && !children) return null

  return (
    <Box
      data-testid={testId}
      sx={(theme) => ({ mt: 2, p: 1.5, borderRadius: 2, border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}` })}
    >
      <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' flexWrap='wrap' sx={{ rowGap: 1 }}>
        <Typography data-testid={`${testId}-summary`} variant='caption' sx={{ color: 'text.secondary' }}>
          {/* El encabezado va SIEMPRE, aunque la lista venga corta: es lo que dice al lector por
              qué estos campos están aquí abajo y no arriba. `headline` deja que cada bloque lo diga
              en sus propias palabras —«Sin documentos» en Documentos, donde lo plegado no son campos
              sino grupos—; sin él, el de siempre. */}
          {[headline || t_('No values'), ...summary].join(' · ')}
        </Typography>
        {!!children && (
          <Button
            data-testid={`${testId}-toggle`}
            size='small'
            variant='outlined'
            onClick={() => setOpen((prev) => !prev)}
            sx={{ textTransform: 'none', borderRadius: CONTROL_RADIUS, minHeight: 44 }}
          >
            {open ? t_('Hide all fields') : (openLabel || t_('See all fields'))}
          </Button>
        )}
      </Stack>
      {open && <Box data-testid={`${testId}-detail`} sx={{ mt: 1.5 }}>{children}</Box>}
    </Box>
  )
}

export default CollapsedFieldsLine
